import { useState, useEffect } from 'react';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useTranslation } from 'react-i18next';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks';
import { DownloadTypes } from '../components/Generic/FileDownload/FileDownload';
import { downloadFile } from '../utils';
import { transactionService } from '../../../../channels/secure-web/services';

const usePrintSwiftConfirmation = () => {
  const [infoForDownload, setInfoForDownload] =
    useState<Nullable<{ orderId: string; accountNumber: string; meta: { timestamp: string } }>>(null);
  const { t } = useTranslation();

  const shouldDownloadTransactionDetails = Boolean(infoForDownload);

  const onDownloadSwiftConfirmationDetails = (orderId: string, accountNumber: string) => {
    setInfoForDownload({ orderId, accountNumber, meta: { timestamp: new Date().toISOString() } });
  };

  const { data: downloadData, isLoading: isLoadingSwiftConfirmationDownloadData } = useInvokeSWRService<{
    report: string;
  }>(
    transactionService.GetSwiftConfirmationPrint,
    {
      orderId: infoForDownload?.orderId,
      accountNumber: infoForDownload?.accountNumber,
      meta: infoForDownload?.meta,
    },
    shouldDownloadTransactionDetails,
  );

  useEffect(() => {
    if (downloadData && infoForDownload) {
      downloadFile(
        `${t('usePrintSwiftConfirmationDoc.title')} ${infoForDownload.orderId}`,
        downloadData.report,
        DownloadTypes.PDF,
      );
    }
  }, [downloadData, t, infoForDownload]);

  return { isLoadingSwiftConfirmationDownloadData, onDownloadSwiftConfirmationDetails };
};

export { usePrintSwiftConfirmation };
